import styled from "styled-components";


export const StyledHome = styled.main`
      
background-color: var(--sec-color);
color: var(--dark-color);
align-items: center;
justify-content: center;
overflow-x: hidden;
 margin: 0 auto;
  padding: 0;
  width: 100%;
  padding-top: 5rem;

/* Footer */

.footer {
  margin: 0;
  padding-top: 10rem;
  background: url(../Homepage/img/footer_bg.svg), no-repeat center/cover;
  background-size: cover;
  width: 100%;
  overflow-x: hidden;
}

.footer .connect i:hover {
  color: var(--pry-color) !important;
  background-color: var(--sec-color) !important;
  border: 1px transparent solid !important;
}
/* Footer */


/* Media Query for Mobile device */
@media screen and (max-width: 780px) {

}
@media screen and (max-width: 580px) {
 
}

/* Media Query for Mobile device */


`;